import {
    ai_tools
  } from "../../js/path";
  import MixinRequest from "../../mixins/request";
  import _ from 'lodash';
  
  export default {
    data() {
      return {
        pageNo: null,
        status: false,
        commuinityStatus: false,
        oldForm: {},
        posts_id: null,
        table_header: [],
        fields: [{
            key: "id",
            sortable: true,
          },
          {
            key: "title",
            label: 'Title'
          },
          {
            key: "slug",
            label: "Slug",
          },
          {
            key: "is_active",
            label: "Status",
          },
          {
            key: "edit",
          },
          {
            key: "delete",
          },
        ],
        params: "",
        tableData: [],
        activeTab: "all",
        key: 0,
        currentPage: 1,
        filter: null,
        filterOn: [],
        sortBy: "id",
        sortDesc: true,
        forum: [],
        partner: [],
        category: [],
        tags: [],
        expert: [],
        knowledgeCategory: [],
        videos: [],
        form: {
          title: "",
          slug: "",
          post_name: "",
          meta_title: "",
          meta_description: "",
          meta_keywords: "",
          category_selected: [],
        },
        image_url: "",
        image: "",
        edit: {
          image_url: null,
        },
      };
    },
    methods: {
      slugify() {
        this.slug = this.form.title;
        if (this.slug) {
          const slug_generate = this.slug
            .toString()
            .trim()
            .toLowerCase()
            .replace(/\s+/g, "-")
            .replace(/[^\w-]+/g, "")
            .replace(/--+/g, "-")
            .replace(/^-+/, "")
            .replace(/-+$/, "");
          this.form.slug = slug_generate;
        } else {
          this.form.slug = null;
        }
      },
      searchFor() {
        if (this.filter.length > 1) this.fetchData(this.activeTab);
        else if (this.filter.length == 0) this.fetchData(this.activeTab);
      },
      filterPage() {
        if (this.pageNo.length > 0) {
          this.params = `&page=${this.pageNo}`;
          this.fetchData(this.activeTab);
          this.currentPage = this.pageNo;
        }
      },
      search(event) {
        if (this.filter.length > 1) {
          if (event.keyCode == 13) {
            this.fetchData(this.activeTab);
          }
        } else if (this.filter.length == 0) this.fetchData(this.activeTab);
      },
      onFiltered(filteredItems) {
        this.totalRows = filteredItems.length;
        this.currentPage = 1;
      },
      async fetchData(txt) {
        let url = null;
        if (txt == "active") {
          this.activeTab = txt;
          if (this.filter != null && this.filter != "") {
            url = ai_tools.getAiToolsUrl + "?filter=" + txt + "&search=" + this.filter;
          } else {
            url = ai_tools.getAiToolsUrl + "?filter=" + txt;
          }
        } else if (txt == "trash") {
          this.activeTab = txt;
          if (this.filter != null && this.filter != "") {
            url = ai_tools.getAiToolsUrl + "?filter=" + txt + "&search=" + this.filter;
          } else {
            url = ai_tools.getAiToolsUrl + "?filter=" + txt;
          }
        } else if (txt == "all") {
          this.activeTab = txt;
          if (this.filter != null && this.filter != "") {
            url = ai_tools.getAiToolsUrl + "?filter=" + txt + "&search=" + this.filter;
          } else {
            url = ai_tools.getAiToolsUrl + "?filter=" + txt;
          }
        }
        url += this.params;
        this.getUrl();
        this.$store.commit("loader/updateStatus", true);
        try {
          const data = await this.getRequest(url);
          if (data.status) {
            const responseData = data.response;
            this.tableData = responseData;
          }
        } catch (err) {
          this.$store.commit("toast/updateStatus", {
            status: true,
            icon: "error",
            title: err.data ? err.data.message : "Please try again!",
          });
        }
        this.$store.commit("loader/updateStatus", false);
        this.key += 1;
      },
      async fetchPosts(id) {
        this.$store.commit("loader/updateStatus", true);
        try {
          let url = ai_tools.getAiToolsUrl + "/" + id;
          this.$store.commit("loader/updateStatus", true);
          const data = await this.getRequest(url);
          this.$store.commit("loader/updateStatus", false);
  
          if (data.status) {
            const responseData = data.response;
  
            if (responseData.title != "" && responseData.title != null) {
              this.form.title = responseData.title;
            }
  
            if (responseData.slug != "" && responseData.slug != null) {
              this.form.slug = responseData.slug;
            }
  
            this.posts_id = responseData.id;
            this.oldForm = _.clone(this.form);
  
          }
        } catch (err) {
          this.$store.commit("toast/updateStatus", {
            status: true,
            icon: "error",
            title: err.data ? err.data.message : "Please try again!",
          });
        }
        this.$store.commit("loader/updateStatus", false);
      },
      async fetchAllCategory() {
        const url = ai_tools.fetchAllActiveCategory;
        const data = await this.getRequest(url);
        if (data.status) {
           this.form.category_selected = data.response.data;
        }
     },
     async fetchCategory(query) {
        const url = ai_tools.fetchAllActiveCategory;
        const data = await this.getRequest(url + "&search=" + query);
        if (data.status) {
           this.category = data.response.data;
        }
     },
      async uploadImage(file) {
        const dataAppend = new FormData();
        // formData.append("file", file);
        if(file){
          dataAppend.append("file", file);
        }

        try {
          const url = ai_tools.uploadImagesCkeditor
          const response = await MixinRequest.methods.postRequest(url, dataAppend);
          if (!response || !response.url) {
            throw new Error("Image upload failed");
          }
          return response.url; // Return S3 image URL
        } catch (error) {
          console.error("Error uploading image:", error);
          throw error;
        }
      },
      async submitData() {
        this.$store.commit("loader/updateStatus", true);
        try {
          let url = ai_tools.getAiToolsUrl;
          if (this.$route.name == "edit-ai-tools") {
            url = ai_tools.getAiToolsUrl + "/" + this.posts_id;
          }
          const payload = {
            title: this.form.title,
            slug: this.form.slug,
          };
          let data;
          if (this.$route.name == "edit-ai-tools") {
            data = await this.putRequest(url, payload);  
          }else{
            data = await this.postRequest(url, payload); // postRequest must send JSON
          }
      
          if (data.status) {
            this.$store.commit("toast/updateStatus", {
              status: true,
              icon: "success",
              title: data.message,
            });
            this.$router.push("/ai/ai-tools");
          }
        } catch (err) {
          this.$store.commit("toast/updateStatus", {
            status: true,
            icon: "error",
            title: err.data ? err.data.message : "Please try again!",
          });
          console.log(err);
        }
        this.$store.commit("loader/updateStatus", false);
      },           
      getUrl() {
        var url = new URL(window.location);
        if (this.activeTab == null || this.activeTab == "") {
          this.activeTab = "all";
        }
        (url.searchParams.has('filter') ? url.searchParams.set('filter', this.activeTab) : url.searchParams.append('filter', this.activeTab));
        if (this.filter != null && this.filter != "") {
          (url.searchParams.has('search') ? url.searchParams.set('search', this.filter) : url.searchParams.append('search', this.filter));
        } else {
          url.searchParams.delete('search');
        }
        if (this.currentPage != null && this.currentPage != "") {
          (url.searchParams.has('page') ? url.searchParams.set('page', this.currentPage) : url.searchParams.append('page', this.currentPage));
        } else {
          url.searchParams.set('page', 1);
        }
        url.search = url.searchParams;
        url = url.toString();
        history.pushState({}, null, url);
      },
      async updateStatus(id) {
        this.$store.commit("loader/updateStatus", true);
        try {
          let index = this.tableData.data.findIndex((e) => e.id === id);
          const url = ai_tools.aiToolUpdateStatus + "/" + id;
          const data = await this.postRequest(url, {
            is_active: !this.tableData.data[index].is_active,
            id: id,
          });
          if (data.status) {
            this.tableData.data[index].is_active = !this.tableData.data[index].is_active;
            this.$store.commit("toast/updateStatus", {
              status: true,
              icon: "success",
              title: data.message,
            });
          }
          this.key += 1;
        } catch (err) {
          this.$store.commit("toast/updateStatus", {
            status: true,
            icon: "error",
            title: err.data ? err.data.message : "Please try again!",
          });
        }
        this.$store.commit("loader/updateStatus", false);
      },
      // async socialUpdateStatus(id) {
      //   this.$store.commit("loader/updateStatus", true);
      //   try {
      //     let index = this.tableData.data.findIndex((e) => e.id === id);
      //     const url = ai_tools.mediBlogPostSocialUpdateStatus + "/" + id;
      //     const data = await this.postRequest(url, {
      //       social_media: !this.tableData.data[index].social_media,
      //       id: id,
      //     });
      //     if (data.status) {
      //       this.tableData.data[index].social_media = !this.tableData.data[index].social_media;
      //       this.$store.commit("toast/updateStatus", {
      //         status: true,
      //         icon: "success",
      //         title: data.message,
      //       });
      //     }
      //     this.key += 1;
      //   } catch (err) {
      //     this.$store.commit("toast/updateStatus", {
      //       status: true,
      //       icon: "error",
      //       title: err.data ? err.data.message : "Please try again!",
      //     });
      //   }
      //   this.$store.commit("loader/updateStatus", false);
      // },
      async deletePosts(id) {
        this.$store.commit("loader/updateStatus", true);
        try {
          let index = this.tableData.data.findIndex((e) => e.id === id);
          const url = ai_tools.getAiToolsUrl + "/" + id;
          const data = await this.postRequest(url, {
            _method: "DELETE",
          });
          if (data.status) {
            this.tableData.data.splice(index, 1);
            this.$store.commit("toast/updateStatus", {
              status: true,
              icon: "success",
              title: data.message,
            });
          }
        } catch (err) {
          this.$store.commit("toast/updateStatus", {
            status: true,
            icon: "error",
            title: err.data ? err.data.message : "Please try again!",
          });
        }
        this.$store.commit("loader/updateStatus", false);
      },
      async restorePosts(id) {
        this.$store.commit("loader/updateStatus", true);
        try {
          let index = this.tableData.data.findIndex((e) => e.id === id);
          const url = ai_tools.restoreAiTools + "/" + id;
          const data = await this.postRequest(url);
          if (data.status) {
            this.tableData.data.splice(index, 1);
            this.$store.commit("toast/updateStatus", {
              status: true,
              icon: "success",
              title: data.message,
            });
          }
        } catch (err) {
          this.$store.commit("toast/updateStatus", {
            status: true,
            icon: "error",
            title: err.data ? err.data.message : "Please try again!",
          });
        }
        this.$store.commit("loader/updateStatus", false);
      },
      tabActive() {
        if (this.activeTab == "trash") {
          if (this.table_header.includes("delete")) {
            let index = this.fields.findIndex((item) => item.key == "delete");
            this.fields[index] = {
              key: "restore",
            };
            let table_index = this.table_header.findIndex(
              (item) => item == "delete"
            );
            this.table_header[table_index] = "restore";
          } else {
            this.table_header.push("restore");
            this.fields.push({
              key: "restore",
            });
          }
  
          if (!this.can("restore-posts")) {
            let index = this.fields.findIndex((item) => item.key == "restore");
            if (index !== -1) {
              this.fields.splice(index, 1);
              let table_index = this.table_header.findIndex(
                (item) => item == "restore"
              );
              this.table_header.splice(table_index, 1);
            }
          }
  
          let index = this.fields.findIndex((item) => item.key == "edit");
          if (index !== -1) {
            this.fields.splice(index, 1);
            let table_index = this.table_header.findIndex(
              (item) => item == "edit"
            );
            this.table_header.splice(table_index, 1);
          }
        } else {
          if (this.table_header.includes("restore")) {
            if (!this.can("edit-ai-tools")) {
              this.fields[3] = {
                key: "delete",
              };
            } else {
              this.fields[4] = {
                key: "delete",
              };
            }
  
            let table_index = this.table_header.findIndex(
              (item) => item == "restore"
            );
            this.table_header[table_index] = "delete";
          }
  
          if (!this.can("edit-ai-tools")) {
            let index = this.fields.findIndex((item) => item.key == "edit");
            if (index !== -1) {
              this.fields.splice(index, 1);
              let table_index = this.table_header.findIndex(
                (item) => item == "edit"
              );
              this.table_header.splice(table_index, 1);
            }
          } else {
            if (!this.table_header.includes("edit")) {
              this.table_header.push("edit");
              this.fields[3] = {
                key: "edit",
              };
            }
          }
  
          if (!this.can("delete-ai-tools")) {
            let index = this.fields.findIndex((item) => item.key == "delete");
            if (index !== -1) {
              this.fields.splice(index, 1);
              let table_index = this.table_header.findIndex(
                (item) => item == "delete"
              );
              this.table_header.splice(table_index, 1);
            }
          } else {
            if (!this.table_header.includes("delete")) {
              this.table_header.push("delete");
              this.fields[4] = {
                key: "delete",
              };
            }
          }
        }
      },
    },
    watch: {
      currentPage: {
        handler: function (value) {
          if (typeof value != undefined) {
            this.params = `&page=${value}`;
            this.fetchData(this.activeTab);
            this.pageNo = this.currentPage;
          }
        },
      },
      activeTab(v) {
        if (v) this.tabActive();
      },
      "form.in_active"(v) {
        if (v == 1) {
          this.in_active = true;
        } else {
          this.in_active = false;
        }
      },
      "form.social_media"(v) {
        if (v == 1) {
          this.social_media = 1;
        } else {
          this.social_media = 0;
        }
      },
      "status"(v) {
        if (v == 1) {
          this.fetchAllCategory();
        } else {
          if (this.$route.name == 'add-ai-tools') {
            this.form.category_selected = [];
          } else if (this.$route.name == 'edit-ai-tools') {
            this.form.category_selected = this.oldForm.category_selected;
          }
        }
      },
    },
    created() {
      if (this.$route.name == "add-ai-tools" || this.$route.name == "edit-ai-tools") {
        if (this.$route.name == "edit-ai-tools") {
          this.fetchPosts(this.$route.params.id);
        }
      } else {
        this.activeTab = "all";
        if (this.$route.query.filter) {
          this.activeTab = this.$route.query.filter;
        }
        if (this.$route.query.search) {
          this.filter = this.$route.query.search;
        }
        if (this.$route.query.page && this.$route.query.page != 1) {
          this.currentPage = parseInt(this.$route.query.page);
        } else {
          this.fetchData(this.activeTab);
        }
      }
      this.fields.map((item) => {
        this.table_header.push(item.key);
      });
      this.tabActive();
    },
  };